module.exports = "/assets/4b3b566c7715b6df19e96bb362d7ab59.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PS.png
// module id = 2851
// module chunks = 0